import React, { useState } from 'react';
import api from '../services/api';
import './AdminUpload.css'; 

const AdminUploadTraCuu = () => {
    const [file, setFile] = useState(null);
    const [source, setSource] = useState('don_vi_thu_mau');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleUpload = async () => {
        if (!file) return alert("Vui lòng chọn file");
        
        setLoading(true);
        setMessage('');
        
        const formData = new FormData();
        formData.append('file', file);
        formData.append('nguon_du_lieu', source);

        try {
            const res = await api.post('/tracuu/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setMessage(`✅ ${res.data.message}`);
            setFile(null);
            document.getElementById('fileInput').value = null;
        } catch (err) {
            setMessage(`❌ Lỗi: ${err.response?.data?.message || 'Upload thất bại'}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-upload-container">
            <h2>Admin - Upload Dữ liệu Tham khảo</h2>
            <div className="upload-box">
                <div style={{marginBottom: '15px'}}>
                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '5px'}}>1. Chọn nguồn dữ liệu:</label>
                    <select 
                        value={source} 
                        onChange={(e) => setSource(e.target.value)}
                        style={{padding: '8px', width: '100%'}}
                    >
                        <option value="don_vi_thu_mau">File Đơn vị Thu mẫu</option>
                        <option value="dc01_mo_rong">File DC01 Mở rộng</option>
                    </select>
                </div>

                <div style={{marginBottom: '15px'}}>
                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '5px'}}>2. Chọn file Excel:</label>
                    <p style={{fontSize: '0.9em', color: 'gray'}}>
                        Cột cần có: <code>ho_ten_tn</code>, <code>nam_sinh_tn</code>, <code>dia_chi_tn</code>, <code>ho_ten_ls</code>, <code>quan_he</code>
                    </p>
                    <input 
                        type="file" 
                        id="fileInput"
                        onChange={(e) => setFile(e.target.files[0])} 
                        accept=".xlsx, .xls"
                    />
                </div>

                <button onClick={handleUpload} disabled={loading} className="btn-primary">
                    {loading ? 'Đang Upload...' : 'Tiến hành Upload'}
                </button>

                {message && <p style={{marginTop: '20px', fontWeight: 'bold'}}>{message}</p>}
            </div>
        </div>
    );
};

export default AdminUploadTraCuu;